import './extensions'
import '@views/style/_global.scss'
import * as components from '@components/globals'
import * as filters from '@utils/filters'
import {
  ValidationObserver,
  ValidationProvider,
  configure,
  setInteractionMode,
} from 'vee-validate'
import App from './App'
import Clipboard from 'v-clipboard'
import Router from 'vue-router'
import Vue from 'vue'
import VueHead from 'vue-head'
import VueLocalStorage from 'vue-localstorage'
import { _ } from '@feathersjs/commons'
import { attachBugsnag } from './bugsnag'
import i18n from './i18n'
import { isProduction } from '@config'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.config.performance = !isProduction

// VeeValidate
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
configure({
  defaultMessage: (_, values) => i18n.t(`rules.${values._rule_}`, values),
})
setInteractionMode('eager')

// global filters
_.each(filters, (filter, name) => Vue.filter(name, filter))

// global components
_.each(components, (component, tag) => Vue.component(tag, component))

Vue.use(Clipboard)
Vue.use(Router)
Vue.use(VueHead)
Vue.use(VueLocalStorage)

// vue-gtag
// Vue.use(VueGtag, {
//   config: { id: googleAnalyticsId },
//   disableScriptLoad: !isDeployedProduction,
//   enabled: isDeployedProduction,
// }, router)

// vue-analytics-facebook-pixel
// Vue.use(VueFacebookPixel)
// if (isDeployedProduction && facebookPixelId) {
//   Vue.analytics.fbq.init(facebookPixelId)
//   Vue.analytics.fbq.event('PageView')
// }

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

Vue.prototype.$recaptchaToken = async function() {
  return 'none'
}

// vue-recaptcha-v3
// if (recaptchaKey) {
//   Vue.use(VueReCaptcha, {
//     siteKey: recaptchaKey,
//     loaderOptions: {
//       autoHideBadge: true,
//     },
//   })
//   Vue.prototype.$recaptchaToken = async function(actionName = 'unnamed') {
//     await this.$recaptchaLoaded()
//     return this.$recaptcha(actionName)
//   }
// }

attachBugsnag()
